import Home from '../../spa/Home';
import NotFound from '../../../../spa/NotFound';

import administracaoRoutes from './administracao';
import ajusteVerbaRoutes from './ajuste-verba';
import alcadaRoutes from './alcada';
import anoFiscalRoutes from './ano-fiscal';
import apuracaoRoutes from './apuracao';
import apuracoesVencidasRoutes from './apuracoes-vencidas';
import carteiraClienteRoutes from './carteira-cliente/carteira-cliente';
import calendarioRoutes from './calendario';
import centroCusto from './centro-custo';
import clienteRoutes from './cliente';
import configuracaoRoutes from './configuracao';
import dashboardRoutes from './dashboard';
import dashboardGerencialRoutes from './dashboard-gerencial';
import divisao from './divisao';
import estruturaUsuarioRoutes from './estrutura-usuario';
import gestaoAprovacao from './gestao-aprovacao';
import importacaoRoutes from './importacoes';
import margemcontribuicao from './margem-contribuicao';
import negociacaoRoutes from './negociacao';
import orcamentoRoutes from './orcamento';
import produtoRoutes from './produto';
import pagamentoRoutes from './pagamento';
import regiaoRoutes from './regiao';
import ssoGrupo from './sso-grupo';
import ssoUsuario from './sso-usuario';
import sellInRoutes from './sell-in';
import sellOutRoutes from './sell-out';
import termoAceite from './termo-aceite';
import tipoAcao from './tipo-acao';
import tipoInvestimentoRoutes from './tipo-investimento';
import tipoOrcamentoRoutes from './tipo-orcamento';
import transferencia from './transferencia';
import transferenciaPosse from './transferencia-posse';
import unidadeMedida from './unidade-medida';
import usuarioRoutes from './usuario';
import workflowRoutes from './workflow';
import acordo from './acordo';

import { hideLoading } from '../../../../common/functions/loading';

const configureGuards = (router) => {
  router.afterEach((route) => {
    if (route.params.menu) {
      hideLoading();
    }
  });
};

export const routes = [
  {
    path: '/',
    name: 'inicio',
    component: Home,
    redirect: '/dashboard',
    children: [
      administracaoRoutes,
      ajusteVerbaRoutes,
      apuracaoRoutes,
      apuracoesVencidasRoutes,
      anoFiscalRoutes,
      alcadaRoutes,
      calendarioRoutes,
      carteiraClienteRoutes,
      centroCusto,
      clienteRoutes,
      configuracaoRoutes,
      dashboardRoutes,
      dashboardGerencialRoutes,
      divisao,
      gestaoAprovacao,
      estruturaUsuarioRoutes,
      importacaoRoutes,
      margemcontribuicao,
      negociacaoRoutes,
      orcamentoRoutes,
      pagamentoRoutes,
      produtoRoutes,
      regiaoRoutes,
      sellInRoutes,
      sellOutRoutes,
      ssoGrupo,
      ssoUsuario,
      termoAceite,
      tipoAcao,
      tipoInvestimentoRoutes,
      tipoOrcamentoRoutes,
      transferencia,
      transferenciaPosse,
      usuarioRoutes,
      unidadeMedida,
      workflowRoutes,
      acordo,
    ],
  },
  {
    path: '*',
    component: NotFound,
  },
];

export const VueRouterObject = {
  routes,
  saveScrollPosition: true,
};

export default (VueRouter) => {
  const vueRouter = new VueRouter(VueRouterObject);
  configureGuards(vueRouter);
  return vueRouter;
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/index.js